







































































import Vue from "vue";
import iwPreviewType from "@/optimizedEncoding/components/packSelection/packPreview/PreviewType.vue";
import iwBillboardPreview from "@/optimizedEncoding/components/packSelection/packPreview/BillboardPreview.vue";
import iwPreviewCard from "@/shared/components/pricing/PreviewCard.vue";
import iwPreviewXlCard from "@/shared/components/pricing/PreviewXlCard.vue";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    components: {
        iwPreviewType: iwPreviewType,
        iwBillboardPreview: iwBillboardPreview,
        iwPreviewCard: iwPreviewCard,
        iwPreviewXlCard: iwPreviewXlCard,
    },
    props: {
        packType: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            isMobile: true,
            isMobilePreview: false,
        };
    },
    computed: {
        classified: function(): Classified {
            return this.$store.getters["FormModule/getCriteria"];
        },
        classifiedId: function(): string {
            return this.$store.getters["FormModule/getClassifiedId"];
        },
        isBillboardSelected: function(): boolean {
            const packOptions = this.$store.getters["FormModule/getValueTransaction"](
                "optimizedEncoding.selectedPackOptions"
            ) || {};
            return !!packOptions[this.packType]?.billboard;
        },
        urlPreview: function(): string {
            return `${process.env.VUE_APP_IMMOWEB_URL}`
                + `/${Trans.currentLocale}`
                + `${process.env.VUE_APP_CLASSIFIEDS_MANAGEMENT_PREVIEW_URL}${this.$t("classified")}`
                +`/${this.classifiedId}`;
        }
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-medium", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });
    },
    methods: {
        updatedPreviewType: function(value: string): void {
            this.isMobilePreview = value === "MOBILE";
        },
        openPreview: function(event: Event) {
            event.preventDefault();
            if(this.urlPreview) {
                window.open(this.urlPreview, "_blank");
                let computedUrl = this.urlPreview as string;
                window.open(computedUrl, "_blank");
            }
        },
    },
});
